import Footer from "@/kyna/includes/Footer";
import HeaderNav from "@/kyna/includes/HeaderNav";
import Link from "next/link";
const TermsAndCondition = () => {
  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* TERMS AND CONDITIONS */}
      <section className="max-w-screen-xl mx-auto lg:mt-44 mt-36 sm:px-10 px-8">
        <div className="grid pb-8">
          <h1 className="md:text-4xl text-3xl leading-tight text-blue text-center mb-12">
            Terms and Conditions
          </h1>
          <div className="grid">
            <h2 className="text-xl uppercase tracking-wider">Registration</h2>
            <ol className="list-[lower-alpha] pl-5">
              <li className="leading-normal pl-4 pb-4">
                You must read, agree with and accept all of these Terms and
                Conditions, which include the terms of use expressly set out
                below and those incorporated by reference before you register as
                a user of this Site (“User”) and PMHA’s Services.
              </li>
              <li className="leading-normal pl-4 pb-4">
                We strongly recommend that, as you read these Terms, you also
                access and read the information contained in the other pages and
                websites referred to herein, as they may contain further terms
                that apply to you as a User.
              </li>
              <li className="leading-normal pl-4 pb-4">
                The PMHA services (“Services”) are available only to, and may
                only be used by individuals who can enter into legally binding
                contracts under Philippine law. Thus, for clients below 18 years
                old, only an authorized guardian or parents will be allowed to
                register on behalf of the client and will have to provide
                consent in availing the Services. You may not use this Site
                and/or the Services if you do not meet the eligibility criteria.
              </li>
              <li className="leading-normal pl-4 pb-4">
                If you are registering as a business entity, you represent that
                you have the authority to bind the business entity to these
                Terms.
              </li>
              <li className="leading-normal pl-4 pb-4">
                Registering for a{" "}
                <b>Philippine Mental Health Association, Inc.</b> account will
                require you to provide us with certain personal details in
                accordance with our{" "}
                <Link href={"/privacy-policy"}>
                  <a className="bg-yellow-100">Privacy Notice</a>
                </Link>
                . In particular, you will be required to disclose your e-mail
                and mobile number, through which PMHA will send you pertinent
                notices, announcements, and the like relating to your
                membership, PMHA’s programs and activities, or Services that
                PMHA is providing you.
              </li>
            </ol>
          </div>
        </div>

        <div className="grid pb-8">
          <h2 className="text-xl uppercase tracking-wider">Use of the Site</h2>
          <ol className="list-[lower-alpha] pl-5">
            <li className="leading-normal pl-4 pb-4">
              You agree to comply with our security verification process.
            </li>
            <li className="leading-normal pl-4 pb-4">
              You shall not transfer, sell or disclose your{" "}
              <b>Philippine Mental Health Association, Inc.</b> account details
              (email address, password, and contact number) to another party.
            </li>
            <li className="leading-normal pl-4 pb-4">
              You agree to comply at all times with these Terms and all
              applicable domestic and international laws, statutes, ordinances,
              and regulations.
            </li>
            <li className="leading-normal pl-4 pb-4">
              You represent and warrant that all information you provide to us
              is accurate and complete.
            </li>
            <li className="leading-normal pl-4 pb-4">
              While we will exert reasonable efforts to maintain accurate and
              up-to-date information on this Site, we make no warranties or
              representations regarding the accuracy, timeliness, or
              completeness of any information found on this Site.
            </li>
            <li className="leading-normal pl-4 pb-4">
              We do not warrant that this Site will always be accessible,
              uninterrupted, timely, error-free, or free from computer viruses
              or other invasive or damaging code or that this website will not
              be affected by any inability to obtain or shortage of necessary
              materials, equipment facilities, power or telecommunications, lack
              of telecommunications equipment or facilities and failure of
              information technology or telecommunications equipment or
              facilities.
            </li>
            <li className="leading-normal pl-4 pb-4">
              Without limiting other remedies, we reserve the right to limit
              User's access to the Site, issue a warning, temporarily suspend,
              indefinitely suspend or terminate User's registration and refuse
              to provide the Services to User if:
            </li>
            <ol className="list-[upper-roman] pl-11">
              <li className="leading-normal pl-4 pb-3">
                The User breaches these Terms or the documents it incorporates
                by reference;
              </li>
              <li className="leading-normal pl-4 pb-3">
                We are unable to verify or authenticate any information the User
                provides to us;
              </li>
              <li className="leading-normal pl-4 pb-3">
                We have reason to believe that the User's account may have been
                compromised; or
              </li>
              <li className="leading-normal pl-4 pb-3">
                We have reason to believe that the User's account may have been
                compromised; or
              </li>
            </ol>
          </ol>
          <p className="pt-3">
            Notwithstanding the foregoing, we reserve the right to terminate or
            suspend access to the Site at any time without assigning any reason.
            We shall not be liable to User or to any other party for any
            damages, losses, costs, or expenses howsoever caused by or arising
            out of such termination or suspension.
          </p>
        </div>

        <div className="grid pb-8">
          <h2 className="text-xl uppercase tracking-wider">No Refund</h2>
          <p className="">
            No refunds of consultation fees, membership fees and other related
            fees will be granted for the delivery of the programs and services.
          </p>
        </div>

        <div className="grid pb-8">
          <h2 className="text-xl uppercase tracking-wider">Charges and Fees</h2>
          <p className="">
            Our charges and fees for providing the Services are shown in the
            Site and are subject to change from time to time at our discretion.
            Unless otherwise stated, all charges are quoted in Philippine Pesos
            (PhP).
          </p>
        </div>

        <div className="grid pb-8">
          <h2 className="text-xl uppercase tracking-wider">
            Indemnity and Limitation of Liability
          </h2>
          <p className="">
            You agree to indemnify and hold harmless the Interested Parties from
            and against any claims, damages, expenses, and/or losses whatsoever
            arising from or in connection with your access to the Site and/or
            use of the Services. "Interested Parties" means the{" "}
            <b>Philippine Mental Health Association, Inc.</b> and the
            individuals through whom its Services are rendered. Notwithstanding
            any other provision herein, in no event shall we be liable for any
            indirect, incidental, special, punitive, exemplary, or consequential
            damages of any kind, nor for any lost profits or revenues, in
            connection with or arising out of these Terms, the operation, use or
            access to this Site, or the provision of the Services.
          </p>
        </div>

        <div className="grid pb-8">
          <h2 className="text-xl uppercase tracking-wider">General</h2>
          <ol className="list-[lower-alpha] pl-5">
            <li className="leading-normal pl-4 pb-4">
              We reserve the right to amend, vary, delete or add to these Terms
              from time to time without prior notice, and the amended Terms
              shall apply with immediate effect. You agree to become bound by
              these Terms of use, as these may be varied from time to time, by
              registration through the Site, and/or by use of the Services.
            </li>
            <li className="leading-normal pl-4 pb-4">
              The invalidity or unenforceability of any provision shall not
              affect any other part of these Terms.
            </li>
            <li className="leading-normal pl-4 pb-4">
              Philippine law shall apply in the interpretation and enforcement
              of these Terms.
            </li>
          </ol>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default TermsAndCondition;
